export const APPLY_INSPECTION_EVENTS = 'APPLY_INSPECTION_EVENTS'

export const SET_AVAILABILITY_DATE = 'SET_AVAILABILITY_DATE'

export const TOGGLE_EVENT_UPDATED = 'TOGGLE_EVENT_UPDATED'

export const NO_DATA_FOUND = 'NO_DATA_FOUND'

export const DELETE_AVAILABILITY = 'DELETE_AVAILABILITY'
